import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import AddClientRecordFields, {
    formValueToCreateRequest,
    initialFormValue,
} from '../../../../shared/ClientRecord/ClientRecordFields';
import { useOrganizationClientRecords } from '../../../../../hooks/api/useOrganizationClientRecords';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';

export type AddClientRecordScreenOwnProps = {};

export type AddClientRecordScreenProps = AddClientRecordScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'add-client-record'>;
};

const AddClientRecordScreen: React.FC<AddClientRecordScreenProps> = () => {
    const goBack = useGoBack();
    const { createClientRecord, isCreatingClientRecord } = useOrganizationClientRecords({
        onCreateClientRecordSuccess: goBack,
    });
    const isDisabled = useIsDisabledByParent(isCreatingClientRecord);

    return (
        <AnimateLoadedContent isLoading={isCreatingClientRecord}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialFormValue}
                    onSubmit={(values) => {
                        const request = formValueToCreateRequest(values);
                        createClientRecord(request);
                    }}
                    onCancel={goBack}
                    isDisabled={isDisabled}
                >
                    {() => <AddClientRecordFields />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddClientRecordScreen);
